import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseGeneralComponent} from '../BaseGeneralComponent';
import {LocalCustomerModel} from '../../models/LocalCustomerModel';
import {ResourcesUnitModel} from '../../models/ResourcesUnitModel';
import {RegionModel} from '../../models/RegionModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../general-services/service-loader/loader.service';
import {ProviderModel} from '../../models/ProviderModel';
import * as toastr from 'toastr';
import {ForecastService} from './service-forecast/forecast.service';
import {ForecastModel} from '../../models/ForecastModel';

@Component({
  selector: 'app-forecast',
  templateUrl: './forecast.component.html',
  styleUrls: ['./forecast.component.scss']
})

export class ForecastComponent extends BaseGeneralComponent implements OnInit, OnDestroy {
  forecastModel: ForecastModel;
  localCustomerSelect: LocalCustomerModel;
  resourceUnitSelect: ResourcesUnitModel;
  regionSelect: RegionModel;
  providerSelect: ProviderModel;

  showActions: boolean;
  showLC: boolean;
  showResourceUnit: boolean;
  showRegion: boolean;

  registerForm: FormGroup;
  submitted = false;
  getPageSubscribe: Subscription;
  sendForecast: Subscription;


  constructor(private route: ActivatedRoute, private router: Router,
              private forecastService: ForecastService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();
    this.showActions = false;
    this.showLC = false;
    this.showRegion = false;
    this.showResourceUnit = false;
    this.forecastModel = new ForecastModel();
    this.providerSelect = new ProviderModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  ngOnInit() {

    this.providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));


    this.registerForm = this.formBuilder.group({
      providerCod: [{value: '', disabled: false}],
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}],
      region: [{value: '', disabled: false}, Validators.required]
    });

    this.registerForm.patchValue({
      providerCod: this.providerSelect ? this.providerSelect.cod : ''
    });

    this.forecastModel.provider = this.providerSelect;

  }

  send() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.sendForecast = this.forecastService.save(this.forecastService.baseUrl + '/newForecast', this.forecastModel)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Forecast not sent', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Forecast sent', 'Success');
              this.loaderService.display(false);
            }
          },
          error => {
            this.loaderService.display(false);
            toastr.error('Forecast not sent', 'Error');
          });
    }
  }

  ngOnDestroy(): void {
  }

  getElementSelectedLC($event) {
    this.forecastModel.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedResourceUnit($event) {
    this.forecastModel.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.forecastModel.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleResourceUnitCod() {
    this.showResourceUnit = !this.showResourceUnit;
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  reset() {
    this.resetLc();
    this.resetResourceUnitCod();
    this.resetRegion();
  }

  resetLc() {
    this.forecastModel.localCustomer = new LocalCustomerModel();
    this.registerForm.patchValue({
      localCustomerCod: ''
    });
    this.localCustomerSelect = new LocalCustomerModel();
  }

  resetResourceUnitCod() {
    this.forecastModel.resourceUnit = new ResourcesUnitModel();
    this.registerForm.patchValue({
      resourceUnit: ''
    });
    this.resourceUnitSelect = new ResourcesUnitModel();
  }

  resetRegion() {
    this.forecastModel.region = new RegionModel();
    this.registerForm.patchValue({
      region: ''
    });
    this.regionSelect = new RegionModel();
  }


}
